<template>
  <div
    class="
      yx-handle-required-page yx-handle-family-page
      predicted-item-page
      main-layout
    "
    v-loading="handleLoading"
  >
    <el-card class="box-form box-inner box-bg">
      <c-title slot="header" title="学习经历(小学开始)"></c-title>
      <div class="pb90">
        <div class="div-scroll" style="padding: 20px">
          <el-row :gutter="20" class="family-row-title">
            <el-col
              :span="item.span"
              v-for="(item, index) in formItems"
              :key="index"
            >
              <span class="red">*</span>
              {{ item.label }}
            </el-col>
            <el-col :span="1"
              ><i class="el-icon-circle-plus-outline" @click="handleAdd"></i
            ></el-col>
          </el-row>

          <el-row
            v-for="(data, k) in pageData"
            :key="k"
            :gutter="20"
            class="family-row-data"
          >
            <el-form
              :model="data"
              :rules="formRules"
              label-width="0"
              :ref="'refForm' + k"
              :disabled="disabled"
            >
              <el-col :span="4">
                <el-form-item prop="startTime">
                  <el-date-picker
                    v-model="data.startTime"
                    type="date"
                    placeholder="选择日期"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate(time) {
                        let oneDay = 24 * 60 * 60 * 1000;
                        if (data.endTime) {
                          let time1 = new Date(data.endTime).getTime() - oneDay;
                          return time.getTime() > time1;
                        }
                      },
                    }"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="endTime">
                  <el-date-picker
                    v-model="data.endTime"
                    type="date"
                    placeholder="选择日期"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    :picker-options="{
                      disabledDate(time) {
                        if (data.startTime) {
                          let time1 = new Date(data.startTime).getTime();
                          return time.getTime() < time1;
                        }
                      },
                    }"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="unit">
                  <el-input v-model="data.unit"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="4">
                <el-form-item prop="job">
                  <el-input v-model="data.job"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item prop="verifyName">
                  <el-input v-model="data.verifyName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="3">
                <el-form-item prop="verifyJob">
                  <el-input
                    v-model="data.verifyJob"
                    maxlength="5"
                    :show-word-limit="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="4">
                <el-form-item>
                  <el-input v-model="data.remark" maxlength="100"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="1"
                ><i
                  class="el-icon-remove-outline"
                  @click="handleDelete(k)"
                  v-if="k >= 1"
                ></i
              ></el-col>
            </el-form>
          </el-row>

          <div class="s-btn">
            <el-button
              type="primary"
              size="large"
              @click="confirm"
              :disabled="isSubmit || disabled"
              >保存</el-button
            >
          </div>
          <div class="tips-container">
            <div class="tips">
              <div class="title">
                <i class="el-icon-info"></i><span>温馨提示</span>
              </div>
              <p>1、以下信息作为学习经历信息登记；</p>
              <p>2、建议从小学学习经历开始填写，填写学习经历项数量≤6；</p>
              <p>注：填写的内容将纳入个人档案，请谨慎填写确保信息真实有效。如有疑问，可联系辅导员。</p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Configs from "../data/experience.js";
import { mapState } from "vuex";
export default {
  name: "",
  data() {
    let { formItems, formRules } = Configs(this);
    return {
      formItems,
      formRules,
      index: "",
      defaultHandleData: {
        unit: "",
        job: "",
        startTime: "",
        endTime: "",
        remark: "",
        verifyName: "",
        verifyJob: "",
      },
      pageData: [],
      isSubmit: false,
      handleLoading: false,
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },

    // 删除单条信息
    handleDelete(index) {
      this.pageData.splice(index, 1);
    },
    // 更新信息
    saveInfo() {
      let params = this.pageData;
      this.isSubmit = true;
      this.handleLoading = true;
      this.$http
        .post("/account/base/student/experience/saveOrUpdate", params)
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success("保存数据成功");
            this.$router.go(-1);
          } else {
            this.$message.error(`'保存数据成功' + ${res.msg}`);
          }
          this.isSubmit = false;
          this.handleLoading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.isSubmit = false;
          this.handleLoading = false;
        });
    },
    confirm() {
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //数组部分的表单，用map返回验证函数的调用
        ...this.pageData.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
      ]).then((res) => {
        if (res) {
          // 全部表单验证通过
          console.log(res);
          this.$confirm("确定修改保存?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.saveInfo();
            })
            .catch(() => {});
        }
      });
    },
    handleAdd() {
      if (this.pageData.length > 5) {
        this.$message.warning("最多可添加6条学习经历信息！");
      } else {
        this.pageData.push({
          unit: "",
          job: "",
          startTime: "",
          endTime: "",
          remark: "",
          verifyName: "",
          verifyJob: "",
        });
      }
    },
    // 获取全部家庭全部成员信息
    getData() {
      this.$http
        .get("/account/base/student/experience/myInfo")
        .then((res) => {
          console.log(res);
          if (res.code == this.SUCCESS_CODE) {
            if (res.data.length) {
              this.pageData = res.data;
            } else {
              this.pageData.push(this.defaultHandleData);
            }
          } else {
            this.pageData.push(this.defaultHandleData);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
